module.exports = __webpack_public_path__ + "static/bannerObject1-3ad0d61c571cd15214b945c6809c2c76.png";